import React, { useEffect } from "react";
import AdyenCheckout from "@adyen/adyen-web";
import "@adyen/adyen-web/dist/adyen.css";
import { useLocation, useNavigate } from "react-router";
import { getRedirectUrl } from "../../data/redirect";
import {data} from "../../data/data";

// This class is used to finalize redirect flows for some payment methods
export const RedirectContainer = () => {
  const location = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    const { config } = data;
    const sessionId = new URLSearchParams(location.search).get('id');
    const redirectResult = new URLSearchParams(location.search).get('redirectResult');

    const createCheckout = async () => {
      const checkout = await AdyenCheckout({
        ...config,
        session: { id: sessionId },
        onPaymentCompleted: (response: any, _component: any) =>
          navigate(getRedirectUrl(response.resultCode), { replace: true }),
        onError: (error: any, _component: any) => {
          console.error(error);
          navigate(`/status/error?reason=${error.message}`, { replace: true });
        },
      });
      checkout.submitDetails({ details: { redirectResult } }); // we finalize the redirect flow with the reeived payload
    };

    createCheckout();
  }, [navigate, location.search])

  return (
    <div id="redirect-page" />
  );
}
